import { Chip, makeStyles } from '@material-ui/core';
import React from 'react';

const ProductTags = ({ tags }) => {
  const classes = useStyles();

  if (!tags || (Array.isArray(tags) && tags.length === 0)) {
    return null;
  }

  return (
    <div className={classes.tagsContainer}>
      {tags.map(tag => (
        <Chip key={tag.id} label={tag.name} size="small" />
      ))}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  tagsContainer: {
    display: 'flex',
    width: '300px',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1)
    }
  }
}));

export default ProductTags;
